import React from 'react';
import _ from 'lodash';

import { CheckboxGroup } from 'components/core';
import useProductQueryParams from 'hooks/use-product-query-params';

import { SidebarFiltersSection } from 'components/sidebar-filters';
import { CategoryOption } from '../category-subcategory-filter/types';

type SubcategoriesFilterMultiSelectProps = {
  subcategories: CategoryOption[] | [];
};

export const SubcategoriesFilterMultiSelect = ({ subcategories }: SubcategoriesFilterMultiSelectProps): JSX.Element => {
  const { defaults, queryParams, setQueryParams } = useProductQueryParams();

  const selectedSubcategories = queryParams.subcategories ?? [];

  const handleSubcategorySelectMulti = (subcategoryValue: string): void => {
    const newSubcategories = _.xor(selectedSubcategories, [subcategoryValue]);
    setQueryParams({ subcategories: newSubcategories, page: defaults.page });
  };

  const options = subcategories.map((subcategory) => ({
    key: subcategory.key,
    value: subcategory.value,
    label: subcategory.label,
  }));

  return (
    <SidebarFiltersSection collapsible={false} heading='Subcategories'>
      <CheckboxGroup
        options={options}
        selectedOptions={selectedSubcategories}
        onSelect={handleSubcategorySelectMulti}
      />
    </SidebarFiltersSection>
  );
};
